import { render, staticRenderFns } from "./PresentationMode.vue?vue&type=template&id=32b3abff&"
import script from "./PresentationMode.vue?vue&type=script&lang=js&"
export * from "./PresentationMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports